import PropTypes from 'prop-types'
import { OtherPageQuery, fetchOtherSSRData } from '@layouts/other'

function Other(props) {
  const { data: ssrData, ...restProps } = props
  return (
    <OtherPageQuery {...restProps} ssrData={ssrData} />
  )
}

Other.propTypes = {
  data: PropTypes.object,
}

Other.getInitialProps = async ({ query, asPath }) => {
  const result = await fetchOtherSSRData({ query })
  return { ...result, asPath }
}

export default Other
